import { useTranslation } from "react-i18next";
import CategoryDropdown from "./CategoryDropdown";
import { MAIN_SITE_URL } from "@/mocks/categories";

const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=A%20bold%20editorial%20flat%20lay%20of%20modern%20streetwear%20fashion%20items%20including%20colorful%20pastel%20sneakers%20a%20folded%20coral%20hoodie%20a%20navy%20cap%20round%20sunglasses%20and%20a%20tan%20backpack%20arranged%20dynamically%20on%20a%20warm%20terracotta%20and%20sand%20gradient%20studio%20backdrop%20with%20soft%20directional%20lighting%20and%20gentle%20long%20shadows%20for%20a%20contemporary%20fashion%20ecommerce%20hero%20banner&width=1600&height=900&seq=usfans-hero-01&orientation=landscape&nocache=true";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[600px] w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="USFans Spreadsheet product finds"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white backdrop-blur-sm">
          {t("heroEyebrow")}
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-bold leading-tight text-white md:text-5xl">
          {t("heroH1")}
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
          {t("heroSub")}
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-primary-600 sm:w-auto"
          >
            {t("heroCta1")}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full whitespace-nowrap rounded-full bg-accent-500 px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-accent-600 sm:w-auto"
          >
            {t("heroCta2")}
          </a>
        </div>

        <p className="mt-6 text-sm text-white/80">{t("heroTrust")}</p>

        <div className="mt-8 w-full max-w-md">
          <CategoryDropdown />
        </div>
      </div>
    </section>
  );
}